import { render, staticRenderFns } from "./ZdmLightingControlWidget.vue?vue&type=template&id=50056da6&"
import script from "./ZdmLightingControlWidget.vue?vue&type=script&lang=js&"
export * from "./ZdmLightingControlWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports